export default "__VITE_PUBLIC_ASSET__1ab43910__"